import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "o-form-login" }
const _hoisted_2 = {
  role: "group",
  class: "mb-6",
  "aria-labelledby": "admin-email-label"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  id: "admin-email-label",
  for: "admin-email",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-sm text-red-500 font-semibold",
    "aria-label": "required"
  }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "admin-email-help",
  class: "sr-only"
}, " Masukkan alamat email admin Anda untuk melanjutkan proses login ", -1)
const _hoisted_5 = { class: "text-xs text-red-500 font-normal" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs text-red-500 font-normal"
}
const _hoisted_7 = {
  role: "group",
  class: "mb-6",
  "aria-labelledby": "admin-password-label"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  id: "admin-password-label",
  for: "admin-password",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Kata sandi "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-sm text-red-500 font-semibold",
    "aria-label": "required"
  }, "*")
], -1)
const _hoisted_9 = ["aria-label", "aria-pressed"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  id: "admin-password-help",
  class: "sr-only"
}, " Masukkan kata sandi admin Anda. Gunakan tombol mata untuk menampilkan atau menyembunyikan kata sandi ", -1)
const _hoisted_11 = { class: "text-xs text-red-500 font-normal" }
const _hoisted_12 = {
  key: 0,
  class: "sr-only"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center my-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-1 border-t border-gray-300" }),
  /*#__PURE__*/_createElementVNode("span", { class: "px-4 text-sm text-gray-500" }, "atau"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-1 border-t border-gray-300" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.64 9.20443C17.64 8.56625 17.5827 7.95262 17.4764 7.36353H9V10.8449H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20443Z",
    fill: "#4285F4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.99976 18C11.4298 18 13.467 17.1941 14.9561 15.8195L12.0475 13.5614C11.2416 14.1014 10.2107 14.4204 8.99976 14.4204C6.65567 14.4204 4.67158 12.8372 3.96385 10.71H0.957031V13.0418C2.43794 15.9831 5.48158 18 8.99976 18Z",
    fill: "#34A853"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.96409 10.7098C3.78409 10.1698 3.68182 9.59301 3.68182 8.99983C3.68182 8.40664 3.78409 7.82983 3.96409 7.28983V4.95801H0.957273C0.347727 6.17301 0 7.54755 0 8.99983C0 10.4521 0.347727 11.8266 0.957273 13.0416L3.96409 10.7098Z",
    fill: "#FBBC05"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.99976 3.57955C10.3211 3.57955 11.5075 4.03364 12.4402 4.92545L15.0216 2.34409C13.4629 0.891818 11.4257 0 8.99976 0C5.48158 0 2.43794 2.01682 0.957031 4.95818L3.96385 7.29C4.67158 5.16273 6.65567 3.57955 8.99976 3.57955Z",
    fill: "#EA4335"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_BInputGroup = _resolveComponent("BInputGroup")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BInputGroupText = _resolveComponent("BInputGroupText")!
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "o-form-login__content",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnterKey && _ctx.handleEnterKey(...args)), ["enter"])),
      role: "form",
      "aria-labelledby": "admin-login-heading"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_BInputGroup, null, {
          default: _withCtx(() => [
            _createVNode(_component_BFormInput, {
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.email) = $event)),
              state: _ctx.v$.email.$errors.length === 0 ? null : false,
              id: "admin-email",
              type: "email",
              class: "placeholder-placeholder-gc",
              placeholder: "Masukkan email anda",
              required: "",
              autocomplete: "email",
              "aria-describedby": "admin-email-errors admin-email-help",
              "aria-invalid": _ctx.v$.email.$errors.length > 0,
              onInput: _ctx.v$.email.$touch,
              onKeydown: _withKeys(_ctx.handleEnterKey, ["enter"])
            }, null, 8, ["modelValue", "state", "aria-invalid", "onInput", "onKeydown"])
          ]),
          _: 1
        }),
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "admin-email-errors",
            class: "input-errors",
            role: "alert",
            "aria-live": "polite",
            key: error.$uid
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(error.$message), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.email, (err, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            role: "alert",
            "aria-live": "polite",
            key: index
          }, [
            err
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(err), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_BInputGroup, null, {
          append: _withCtx(() => [
            _createVNode(_component_BInputGroupText, { class: "border-l-0 bg-transparent" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  id: "admin-password-visibility-toggle",
                  class: "cursor-pointer text-placeholder-gc bg-transparent border-0 p-0 focus:outline-none focus:ring-2 focus:ring-primary-gc focus:ring-offset-1",
                  "aria-label": 
                  _ctx.isShowPassword
                    ? 'Tampilkan kata sandi'
                    : 'Sembunyikan kata sandi'
                ,
                  "aria-pressed": !_ctx.isShowPassword,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                  onKeydown: [
                    _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args)), ["enter"])),
                    _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args)), ["prevent"]), ["space"]))
                  ]
                }, [
                  _createVNode(_component_FontAwesomeIcon, {
                    icon: _ctx.isShowPassword ? 'eye' : 'eye-slash',
                    "aria-hidden": "true"
                  }, null, 8, ["icon"])
                ], 40, _hoisted_9)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BFormInput, {
              modelValue: _ctx.formData.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
              state: _ctx.v$.password.$errors.length === 0 ? null : false,
              type: _ctx.isShowPassword ? 'password' : 'text',
              class: _normalizeClass(`placeholder-placeholder-gc ${
              _ctx.v$.password.$errors.length === 0 ? 'border-r-0' : ''
            }`),
              id: "admin-password",
              placeholder: "Masukkan kata sandi anda",
              required: "",
              autocomplete: "current-password",
              "aria-describedby": "admin-password-errors admin-password-help admin-password-visibility-toggle",
              "aria-invalid": _ctx.v$.password.$errors.length > 0,
              onInput: _ctx.v$.password.$touch,
              onKeydown: _withKeys(_ctx.handleEnterKey, ["enter"])
            }, null, 8, ["modelValue", "state", "type", "class", "aria-invalid", "onInput", "onKeydown"])
          ]),
          _: 1
        }),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "admin-password-errors",
            class: "input-errors",
            role: "alert",
            "aria-live": "polite",
            key: error.$uid
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createVNode(_component_BButton, {
        type: "submit",
        variant: "warning",
        class: "w-full text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-primary-gc focus:ring-offset-2",
        disabled: _ctx.isLoading,
        "aria-label": 
          _ctx.isLoading ? 'Sedang memproses login...' : 'Masuk ke panel admin'
        ,
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Sedang memproses..."))
            : _createCommentVNode("", true),
          _createTextVNode(" Masuk ")
        ]),
        _: 1
      }, 8, ["disabled", "aria-label", "onClick"]),
      _hoisted_13,
      _createVNode(_component_BButton, {
        type: "button",
        variant: "outline-secondary",
        class: "w-full text-sm font-semibold flex items-center justify-center gap-2 focus:outline-none focus:ring-2 focus:ring-primary-gc focus:ring-offset-2",
        disabled: _ctx.isLoading,
        "aria-label": "Masuk dengan Google",
        onClick: _ctx.submitGoogleLogin
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _createTextVNode(" Masuk dengan Google ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ], 32)
  ]))
}